<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="text-right">
        <v-btn color="primary" :to="{ name: 'plan.new' }"> Novo plano </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="plans"
          :loading="isLoading"
          v-model:page="page"
          v-model:items-per-page="itemsPerPage"
          :items-length="totalItems"
          :items-per-page-options="[
            { value: 10, title: '10' },
            { value: 20, title: '20' },
            { value: 30, title: '30' },
            { value: 40, title: '40' },
            { value: 50, title: '50' },
          ]"
        >
          <template v-slot:item.monthly_price="{ item }">
            R$ {{ item.monthly_price }}
          </template>
          <template v-slot:item.annual_price="{ item }">
            R$ {{ item.annual_price }}
          </template>
          <template v-slot:item.actions="{ item }">
            <router-link
              :to="{ name: 'plan.edit', params: { planId: item.id } }"
            >
              <v-icon :icon="mdiPencil" />
            </router-link>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, computed, watch } from "vue";
import { mdiPencil } from "@mdi/js";
import { usePlansQuery } from "@/queries/modules/plans";
import { useSnackbar } from "@/plugins/snackbar";

const snackbar = useSnackbar();

const page = ref(1);
const itemsPerPage = ref(10);

const headers = [
  { title: "Descrição", key: "description" },
  { title: "Preço mensal", key: "monthly_price" },
  { title: "Preço anual", key: "annual_price" },
  { title: "", key: "actions", sortable: false },
];

// Query params - reactive to page changes
const queryParams = computed(() => ({
  page: page.value,
  per_page: itemsPerPage.value,
}));

// Use TanStack Query for plans
const { data: plansData, isLoading, error } = usePlansQuery(queryParams);

// Computed properties
const plans = computed(() => plansData.value?.items || []);
const totalItems = computed(() => plansData.value?.total || 0);

// Watch for errors
watch(error, (err) => {
  if (err) {
    snackbar.error(
      `Ocorreu um erro ao carregar a lista de planos: ${err.message}`,
    );
  }
});
</script>
